import { injectable, inject } from 'inversify';
import type { IAdicionalRepository } from '@/domain/repositories/IAdicionalRepository';
import { TYPES } from '@/di/tokens';

@injectable()
export class ToggleAdicionalStatusAction {
  constructor(
    @inject(TYPES.IAdicionalRepository)
    private adicionalRepository: IAdicionalRepository
  ) {}

  async execute(id: number): Promise<void> {
    await this.adicionalRepository.toggleStatus(id);
  }
}
